<script>

import moment from "moment";
import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
import PageHeader from "@/components/page-header";
import UploadFiles from "@/views/widgets/upload-files";

import {
  createWorkOrder,
  patchRepairService,
  customerDetail,
  postCustomerContact,
  patchOpportunity
} from "@/service";
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {alertError, successMsg} from "@/helpers/swal";
import CustomerSelect from "@/views/work-order/components/widgets/customer-select";
import ServiceCompanySelect from "@/views/work-order/components/widgets/service-company-select";
import EngineerSelect from "@/views/work-order/components/widgets/engineer-select";
import DeviceSelect from "@/views/widgets/device-select";
// import _ from "lodash";
import {getCustomerContactList, updateFiles} from "@/helpers/common-service";
// import {WO_TYPE, WO_TYPE_EQUIPMENT_REPAIR, WO_TYPE_EQUIPMENT_TROUBLE_SHOOTING, WO_TYPE_EQUIPMENT_MAINTENANCE, WO_TYPE_EQUIPMENT_COMMISSION, SERVICE_STATUS_PROCESSED} from "@/config/common";
import {WO_TYPE_LIST, SERVICE_STATUS_PROCESSED, WO_TYPE_EQUIPMENT_MAINTENANCE,BUSINESS_STATUS_CONVERTED,WO_TYPE_EQUIPMENT_QR_CODE} from "@/config/common";
import {addressText} from "@/helpers/common";
import _ from "lodash";
import i18n from "@/i18n";
import MaintenanceSelect from "@/views/widgets/maintenance-select.vue";


export default {
  setup: () => ({ v$: useVuelidate() }),
  page: {
    title: i18n.global.t('page.work-order.create-order'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },]
  },
  data () {
    return {
      WO_TYPE_LIST,
      WO_TYPE_EQUIPMENT_MAINTENANCE,
      WO_TYPE_EQUIPMENT_QR_CODE,
      title: i18n.global.t('page.work-order.create-order'),
      datetimeConfig: {
        enableTime: false,
        dateFormat: "Y-m-d",
        time_24hr: false,
      },
      woTypeOptions:[],
      form: {
        type: null,
        // 维护保养名称
        maintain_name: null,
        // customer id
        customer: null,
        customer_address: null,
        customer_contact: null,
        customer_contact_number: null,
        device_root_sn: null,
        device_name: null,
        device_id: null,
        priority: 1,
        expectation_at: null,
        plan_start_at: null,
        plan_end_at: null,
        content: null,
        // 维护项
        save_maintain_item_ids: [],
        // 服务商ID
        service_company: null,
        main_engineer: null,
        assist_engineer: null,
        attachment: [],
        // 转工单的服务请求ID
        service_request: null,
      },
      files: [],
      showFileList: false,
      alertInfo: {
        variant: "danger",
        content: "",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      // 请求数据
      serviceData: {},
      contactsList: [], // 联系人列表
      currentCustomer: null, // 当前选择的客户
      submitLoading: false,
      submitted: false,
      currentGroupSn: null,
      currentProductType: null,
      // 维护项目选项
      repairs: [],
    }
  },
  validations: {
    form: {
      customer: { required },
      customer_contact: { required },
      device_root_sn:{ required },
      customer_contact_number: { required },
      // content: { required },
      type: { required },
    }
  },
  mounted() {
    //增加贴二维码
    this.woTypeOptions = [...this.WO_TYPE_LIST]
    this.woTypeOptions.unshift({ value: WO_TYPE_EQUIPMENT_QR_CODE, label: i18n.global.t("page.work-order.type.QR-code") });


    if(this.$route.params.type != '0'){ //排除掉未分类的工单类型
      this.form.type = this.$route.params.type
    }

    // 请求转工单时，获取请求数据
    const serviceData = localStorage.getItem('serviceData')
    localStorage.removeItem('serviceData')
    if (serviceData) {
      this.serviceData = JSON.parse(serviceData)
      console.log('工单数据',this.serviceData);

      if (this.serviceData.id) {
        //判断是否商机转化
        if(this.$route.query.task_id){ //商机转化,无联系人
          this.form.task_id = this.serviceData.id
          this.form.customer_contact = this.serviceData.customer_contact
          this.form.priority = 1 //默认紧急程度为不紧急
          this.form.service_company = this.serviceData.service_company
          //设备保养
          this.form.type = WO_TYPE_EQUIPMENT_MAINTENANCE 
          this.form.maintain_name = this.serviceData.maintain_name
        }else{
          this.form.service_request = this.serviceData.id
        }

        // 请求中的一些数据填充到工单里
        this.form.customer = this.serviceData.customer      
        this.form.device_root_sn = this.serviceData.device_root_sn
        this.form.device_name = this.serviceData.device_name
        this.form.customer_address = this.serviceData.customer_address
        this.form.expectation_at = this.serviceData.expectation_at

        if (this.serviceData.customer) {
          getCustomerContactList(this.form.customer).then(res => {
            // console.log('已获取当前请求客户下的联系人列表')
            this.contactsList = res
            this.form.customer_contact_number = this.serviceData.customer_contact_number
            this.form.customer_contact = this.serviceData.customer_contact
            // console.log('请求中获取到的联系人ID和电话写入form', this.form.customer_contact, this.form.customer_contact_number)
          })
        }
      }
    }

  },
  computed: {
    showMaintainInput() {
      return this.form.type == WO_TYPE_EQUIPMENT_MAINTENANCE
    },
    maintainNameError() {
      return this.showMaintainInput && !this.form.maintain_name
    },
    contentError() {
      let reslut = false
      /* 是否是设备保养项目 */
      if(this.displayRepairs.length && this.showMaintainInput){
        if(!this.form.save_maintain_item_ids.length){
          reslut = true
        }
      }else{
        if(!this.form.content){
          reslut = true
        }
      }
      return reslut
    },
    displayRepairs() {
      return this.repairs.filter(item => item.name == this.form.maintain_name)
    }
  },
  methods: {
    moment,
    // 勾选维保项目
    handleMaintainItemChange(value) {
      this.form.save_maintain_item_ids = _.xor(this.form.save_maintain_item_ids, [value])
    },
    // 选择客户后自动填充其他相关字段
    setCurrentCustomer(value) {
      this.currentCustomer = value
      if (this.currentCustomer) {
        this.form.customer = this.currentCustomer.id
        this.form.device_root_sn = null
        this.form.device_name = null
        this.form.device_id = null
        // 查客户详情获取地址
        customerDetail(this.form.customer).then(res => {
          const detail = res.payload
          this.form.customer_address = addressText(detail)
        })
        // 清空联系人
        // console.log('由于客户变化，清空form中的联系人ID和联系人电话')
        this.form.customer_contact = null
        this.form.customer_contact_number = null
        // 获取该客户下的联系人列表
        getCustomerContactList(this.currentCustomer.id).then(res => {
          this.contactsList = res
        })
      }
    },
    // 选择电话后自动填充联系人ID
    setCurrentContactName(value) {
      // console.log('联系人电话变化: ', value  )
      const contact = _.find(this.contactsList, {tel: value})
      if (contact) {
        // console.log('电话在列表中有，设置联系人ID为：', contact.id)
        this.form.customer_contact = contact.id
      } else if(typeof this.form.customer_contact === 'number') {
        // console.log('电话在列表中没有,且当前选择了联系人ID，清空联系人ID，期待输入联系人姓名')
        this.form.customer_contact = null
      }
    },
    // 选择联系人后自动填充联系人电话
    setCurrentContactTel(value) {
      // console.log('联系人ID或姓名变化: ', value)
      const contact = _.find(this.contactsList, {id: value})
      if (contact) {
        // console.log('联系人ID在列表中有，设置联系人电话为：', contact.tel)
        this.form.customer_contact_number = contact.tel
      } else if (_.find(this.contactsList, {tel: this.form.customer_contact_number})) {
        // console.log('联系人ID在列表中没有，但是电话在列表中有，清空联系人电话，期待输入联系人电话')
        this.form.customer_contact_number = null
      }
    },
    // 类型改变后
    typeChange(value) {
      this.form.save_maintain_item_ids = []
      if (value == WO_TYPE_EQUIPMENT_MAINTENANCE) {
        if(!this.form.maintain_name)this.form.maintain_name = 4
      } else {
        this.form.maintain_name = null
      }
    },
    deviceChange(val) {
      this.form.device_root_sn = val.root_sn
      this.form.device_name = val.name
      this.form.device_id = val.id
      this.currentGroupSn = val.group_sn
      this.currentProductType = val.product_type
      this.repairs = val.repairs
    },
    // 选择服务商后获取对应服务商下的工程师
    serviceCompanyChange(value) {
      this.form.main_engineer = null
      this.form.assist_engineer = null
      this.form.service_company = value
    },
    // 选择主工程师
    mainEngineerChange(value) {
      this.form.main_engineer = value
    },
    // 选择协助工程师
    assistEngineerChange(value) {
      this.form.assist_engineer = value
    },
    // 附件选择
    filesUpload(file, type) {
      if (!file) {
        return;
      }
      if (type == "add") {
        updateFiles(file[0], type, 'wo').then(res => {
          this.showFileList = true;
          this.files.push(res);
          this.form.attachment.push(res.id);
        });
      } else {
        updateFiles(file, type).then(() => {
          document.querySelector("#filesUpload").value = "";
          this.files = this.files.filter((f) => {
            return f.object_name != file.object_name;
          });
        });
      }
    },
    async save() {
      this.submitted = true
      if (this.submitLoading) {
        return
      }

      this.v$.form.$touch()
      const result = await this.v$.$validate()
      if (!result) {
        return;
      }
      if (this.maintainNameError) {
        return;
      }
      // if( this.$route.query.create&&!(this.form.content&&this.form.content.length)){
      //   return;
      // }
      if( this.$route.query.create&&this.contentError){
        /* 工单内容校验未通过 */
        return;
      }
      this.submitLoading = true

      // 如果联系人列表中没有，则新建联系人，再保存工单
      if (!_.find(this.contactsList, ['id', this.form.customer_contact])) {
        const contactData = {
          customer: this.form.customer,
          name: this.form.customer_contact,
          tel: this.form.customer_contact_number,
        }
        postCustomerContact(contactData).then((res) => {
          this.form.customer_contact = res.payload.id
          this.saveOrder()
        }).catch(err => {
          this.submitLoading = false
          console.log(err)
          alertError(this.$t('base.prompt'), this.$t('page.work-order.create-customer-contact-error'))
        })
      } else {
        // 直接保存
        this.saveOrder()
      }
    },
    saveOrder() {
      const params = { ...this.form }
      if (!params.content) {
        params.content = '-'
      }
      // delete params.customer_contact_number
      createWorkOrder(params).then(res => {
        if (![200, 201].includes(res.meta.code)) {
          this.submitLoading = false
          alertError(this.$t('base.prompt'), res.meta.message)
          return;
        }
        //截断：商机转化，保养计划处理
        if(this.$route.query.task_id){ //商机转化,无联系人
          this.changeOpportunity(this.form, res.payload.id)
          return;
        }
        // 如果有请求，把请求状态改成已处理
        if (this.form.service_request) {
          patchRepairService(this.form.service_request, {
            status: SERVICE_STATUS_PROCESSED
          }).then(() => {
            successMsg(this.$t('page.work-order.create-order-success'))
            this.submitLoading = false
            this.goBack()
          }).catch(err1 => {
            this.submitLoading = false
            alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
            console.log(err1)
          })
        } else {
          successMsg(this.$t('page.work-order.create-order-success'))
          this.submitLoading = false
          this.goBack()
        }
      }).catch(err => {
        this.submitLoading = false
        alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
        console.log(err)
      })
    },
    goBack() {
      this.$router.push('/work-order')
      // if (this.form.type == WO_TYPE_EQUIPMENT_REPAIR) {
      //   this.$router.push('/work-order-repair')
      // } else if (this.form.type == WO_TYPE_EQUIPMENT_MAINTENANCE) {
      //   this.$router.push('/work-order-maintenance')
      // } else if (this.form.type == WO_TYPE_EQUIPMENT_COMMISSION) {
      //   this.$router.push('/work-order-comission')
      // } else if (this.form.type == WO_TYPE_EQUIPMENT_TROUBLE_SHOOTING) {
      //   this.$router.push('/work-order-troubleshooting')
      // } else {
      //   this.$router.go(-1)
      // }
    },
    /* 改商机状态 */ 
    changeOpportunity(item,work_order_id){
      const form1 = {
        id: item.task_id,
        status: BUSINESS_STATUS_CONVERTED,
        work_order: work_order_id,
        // transform_at: toUtcFormat(moment().format('YYYY-MM-DD HH:mm:ss'))
        transform_at: moment().format("YYYY-MM-DD"),
      };
      patchOpportunity(form1)
        .then(() => {
          this.$message.success(this.$t("base.operate_success"));

          // 新打开tab页跳转到工单详情
          const route = this.$router.resolve({
            path: `/work-order-detail/${form1.work_order}`,
          });
          window.open(route.href, "_blank");
        })
        .catch((err) => {
          this.$message.error(this.$t("page.errorOccurred"));
          console.log(err);
        });
    }
  },
  components: {
    Layout,
    PageHeader,
    UploadFiles,
    CustomerSelect,
    ServiceCompanySelect,
    EngineerSelect,
    DeviceSelect,
    MaintenanceSelect,
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="[]" />
    <b-row class="bottom-place">
      <b-col>
        <b-card no-body>
          <b-card-header>
            <h5 class="card-title mb-0">{{$t('page.basic-info')}}</h5>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col lg="6">
                <div class="mb-3">
                  <label class="form-label" for="meta-title-input">{{ $t('menu.business-partner.customer') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
                  <customer-select :selected-customer-id="form.customer" :is-invalid="v$.form.customer.$errors.length" @changed="setCurrentCustomer" />
                  <div class="mt-1" v-if="v$.form.customer.$errors.length"><span class="text-danger">{{ $t('page.work-order.customer-required') }}</span></div>
                </div>
              </b-col>
              <b-col lg="6">
                <div class="mb-3">
                  <label class="form-label" for="meta-keywords-input">{{ $t('page.work-order.address') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('page.work-order.address')" v-model="form.customer_address"/>
                </div>
              </b-col>
            </b-row>
            <b-row cols="3">
              <b-col>
                <div class="mb-3" :class="v$.form.device_root_sn.$errors.length ? 'was-validated' : ''">
                  <label class="form-label" for="meta-keywords-input">
                    {{ $t('page.work-order.device-root-sn') }}
                    <span class="text-danger">（{{ $t('base.required') }}）</span>
                    <span v-if="currentProductType == 1 && currentGroupSn">（{{this.$t('page.unit_serial_number')}}：{{ currentGroupSn }}）</span>
                  </label>
                  <DeviceSelect
                      :isInvalid="v$.form.device_root_sn.$errors.length?true:false"
                      :customer-id="form.customer"
                      :selected-device-root-sn="form.device_root_sn"
                      @changed="deviceChange"
                  />
                  <div class="mt-1" v-if="v$.form.device_root_sn.$errors.length"><span class="text-danger">{{ $t('page.work-order.root-sn-required') }}</span></div>
                </div>
              </b-col>
              <b-col>
                <div class="mb-3" :class="v$.form.customer_contact_number.$errors.length ? 'was-validated' : ''">
                  <label class="form-label" for="meta-title-input">{{ $t('page.work-order.contact-phone') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
                  <Multiselect
                      :class="v$.form.customer_contact_number.$errors.length ? 'is-invalid' : ''"
                      class="form-control"
                      v-model="form.customer_contact_number"
                      :placeholder="$t('page.work-order.contact-phone')"
                      value-prop="tel"
                      label="tel"
                      @change="setCurrentContactName"
                      :close-on-select="true"
                      :searchable="true"
                      :create-option="true"
                      :options="contactsList"
                  />
                  <div class="mt-1" v-if="v$.form.customer_contact_number.$errors.length"><span class="text-danger">{{ $t('page.work-order.contact-phone-required') }}</span></div>
                </div>
              </b-col>
              <b-col>
                <div class="mb-3" :class="v$.form.customer_contact.$errors.length ?'was-validated' : ''">
                  <label class="form-label" for="meta-title-input">{{ $t('page.work-order.contact') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
                  <Multiselect
                      :class="v$.form.customer_contact.$errors.length ? 'is-invalid' : ''"
                      class="form-control"
                      v-model="form.customer_contact"
                      :placeholder="$t('page.contact')"
                      value-prop="id"
                      label="name"
                      @change="setCurrentContactTel"
                      :close-on-select="true"
                      :searchable="true"
                      :create-option="true"
                      :options="contactsList"
                  />
                  <div class="mt-1" v-if="v$.form.customer_contact.$errors.length">
                    <span class="text-danger">{{ $t('page.work-order.contact-required') }}</span></div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-3" :class="v$.form.type.$errors.length ? 'was-validated' : ''">
              <b-col>
                <label class="form-label" for="meta-keywords-input">{{$t('page.work-order.type.text') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
                <div>
                  <Multiselect
                      class="form-control"
                      :class="v$.form.type.$errors.length ? 'is-invalid' : ''"
                      v-model="form.type"
                      :close-on-select="true"
                      :searchable="false"
                      :options="woTypeOptions"
                      :placeholder="$t('page.select-type')"
                      @change="typeChange"
                  />
                </div>
                <div class="mt-1" v-if="v$.form.type.$errors.length"><span class="text-danger">{{ $t('page.work-order-type-required') }}</span></div>
              </b-col>
              <b-col v-show="showMaintainInput">
                <label class="form-label" for="meta-keywords-input">{{$t('page.maintenance-name') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
                <maintenance-select
                  v-model:value="form.maintain_name"
                  :is-invalid="maintainNameError && submitted"
                  :show-tips-when-err="true"
                ></maintenance-select>
              </b-col>
              <b-col>
                <div class="mb-3">
                  <label class="form-label" for="meta-keywords-input">{{ $t('page.expected-service-time') }}</label>
                  <flat-pickr v-model="form.expectation_at" :config="datetimeConfig" :placeholder="$t('page.select-time')"
                              class="form-control"></flat-pickr>
                </div>
              </b-col>
              <!-- 紧急程度 -->
              <b-col cols="4">
                <label class="form-label" for="meta-keywords-input">{{ $t('page.work-order.priority.text') }}<span class="text-danger">（{{$t('base.required')}}）</span></label>
                <div>
                  <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                    <input type="radio" class="btn-check" name="btnradio" autocomplete="off" id="btnradio1" :value="1" v-model="form.priority">
                    <label class="btn btn-outline-success" for="btnradio1">{{ $t('page.work-order.priority.not-urgent') }}</label>

                    <input type="radio" class="btn-check" name="btnradio" autocomplete="off" id="btnradio2" :value="2" v-model="form.priority">
                    <label class="btn btn-outline-warning" for="btnradio2">{{ $t('page.work-order.priority.urgent') }}</label>

                    <input type="radio" class="btn-check" name="btnradio" autocomplete="off" id="btnradio3" :value="3" v-model="form.priority">
                    <label class="btn btn-outline-danger" for="btnradio3">{{ $t('page.work-order.priority.very-urgent') }}</label>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="mb-3">
                  <label class="form-label">{{ $t('page.work-order-content') }}<span class="text-danger">（{{$t('base.required')}}）</span></label>
                  <div class="content-part border rounded-2" :class="[contentError && submitted && 'box-is-invalid']">
                    <div class="maintain-content border-bottom-dashed px-3 pt-2" v-show="displayRepairs.length && showMaintainInput">
                      <div>{{ $t('page.maintenance-item') }}</div>
                      <span class="text-muted mt-1">{{ $t('page.please-check-maintenance-item') }}</span>
                      <div class="checkbox-list mt-2">
                        <div class="form-check mb-2 d-flex align-items-center" v-for="(item, index) in displayRepairs" :key="index">
                          <input class="form-check-input mt-0" :checked="form.save_maintain_item_ids.includes(item.id)" @click="handleMaintainItemChange(item.id)" type="checkbox">
                          <span class="ms-1 cursor-pointer" @click="handleMaintainItemChange(item.id)">{{ item.item_name }}</span>
                          <el-tooltip
                              class="box-item"
                              effect="dark"
                              placement="top"
                              :teleported="false"
                              v-if="item.description&&item.description.length>0"
                          >
                            <template #content>
                              <div style="width:180px;font-size: 13px">
                                {{item.description}}
                              </div>
                            </template>
                            <i class="ri-information-line ms-1 cursor-pointer text-primary" style="font-size: 1rem;"></i>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <textarea class="form-control border-0" v-model.trim="form.content" :placeholder="$t('page.please-enter-content')"></textarea>
                  </div>
                  <div class="mt-1" v-if="contentError && submitted"><span class="text-danger">{{ $t('page.work-order-content-required') }}</span></div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <UploadFiles
                    input-file-id="filesUpload"
                    :title="$t('page.attachment')"
                    :files="files"
                    :showFileList="showFileList"
                    @changed="filesUpload"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="text-end">
          <button class="btn btn-outline-primary me-3 px-5" @click="this.$router.go(-1)">{{ $t('base.cancel') }}</button>
          <button class="btn btn-primary px-5" @click="save">
            <span class="d-flex align-items-center">
              <span>{{ $t('base.submit') }}</span>
              <span v-if="submitLoading" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
            </span>
          </button>
        </div>
      </b-col>
      <b-col cols="4">
        <b-card no-body>
          <b-card-header>
            <h5 class="card-title mb-0">{{this.$t('page.work-order.ServiceInformation')}}</h5>
          </b-card-header>
          <b-card-body>
            <div class="mb-3">
              <label for="choices-publish-status-input" class="form-label">{{ $t('page.service-company') }}</label>
              <service-company-select :selected-service-company="form.service_company" @changed="serviceCompanyChange" />
            </div>
            <div class="mb-3">
              <label for="choices-publish-status-input" class="form-label">{{$t('page.engineer')}}</label>
              <!-- <engineer-select :value="form.main_engineer" @changed="mainEngineerChange" :company-id="form.service_company"></engineer-select> -->
              <engineer-select :is-disabled="true" :placeholoderText="$t('page.service-agent-supplement')"></engineer-select>
            </div>
            <div class="mb-3" style="display: none">
              <label for="choices-publish-status-input" class="form-label">{{ $t('page.assist-engineer') }}</label>
              <engineer-select @changed="assistEngineerChange" :value="form.assist_engineer" :company-id="form.service_company" :exclude-engineer-id="form.main_engineer"></engineer-select>
            </div>
            <div class="mb-3" style="display: none">
              <label for="choices-publish-status-input" class="form-label">{{ $t('page.expected-arrival-time') }}</label>
              <flat-pickr v-model="form.plan_start_at" :config="datetimeConfig" :placeholder="$t('page.select-time')"
                          class="form-control"></flat-pickr>
            </div>
            <div class="mb-3" style="display: none">
              <label for="choices-publish-status-input" class="form-label">{{ $t('page.expected-completion-time') }}</label>
              <flat-pickr v-model="form.plan_end_at" :config="datetimeConfig" :placeholder="$t('page.select-time')"
                          class="form-control"></flat-pickr>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
  <message-alert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
  ></message-alert>
</template>
